var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "white-eye",
    width: "54px",
    height: "32px",
    viewBox: "0 0 54 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white-eye-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "white-eye-2",
    transform: "translate(-5.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "white-eye-3",
    transform: "translate(5.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "white-eye-4",
    d: "M27,32 C36.9411255,32 45.9411255,26.6666667 54,16 C45.9411255,5.33333333 36.9411255,0 27,0 C17.0588745,0 8.0588745,5.33333333 0,16 C8.0588745,26.6666667 17.0588745,32 27,32 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "white-eye-5",
    fill: "#151515",
    cx: 27,
    cy: 16,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    id: "white-eye-6",
    fill: "#FFFFFF",
    cx: 27,
    cy: 16,
    r: 7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteEye);
export default __webpack_public_path__ + "static/media/white-eye.962f6e29d902026759c95c9ba45ac25d.svg";
export { ForwardRef as ReactComponent };